import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { getsearchData } from "../helpers/api/projectData"; // Removed fetchToken from import
import { formatToINR } from "../helpers/helperFunctions";
import { BiLoaderCircle } from "react-icons/bi";

const NewModalCard = ({ showModal, setShowModal, props }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isError, setError] = useState(false);

  useEffect(() => {
    if (showModal && !data) {
      const fetchData = async () => {
        try {
          setLoading(true);
          const reqObj = {
            includeTransactionDetails:
              props.includeTransactionDetails || "No",
            projectCategoryId: props.projectCategoryId || "",
            projectId: props.projectId || "",
            projectTransDateFrom: props.projectTransDateFrom || "",
            projectTransDateTo: props.projectTransDateTo || "",
          };
          const queryResp = await getsearchData(reqObj);
          setLoading(false);
          const dataArr = queryResp.ProjTransLine.map((data) => ({
            ProjectTransDate: data.ProjectTransDate,
            PostedAmount: data.PostedAmount,
            UnpostedAmount: data.UnpostedAmount,
          }));
          setData(dataArr);
        } catch (error) {
          setError(true);
          setLoading(false);
          console.error("Error fetching modal data:", error);
        }
      };
      fetchData();
    }
  }, [showModal, data, props]);

  const handleClose = () => setShowModal(false);

  const getTotalPosted = (data) => {
    let totalCount = 0;
    data.forEach((value) => {
      totalCount = totalCount + value.PostedAmount;
    });
    return totalCount;
  };
  const getTotalUnposted = (data) => {
    let totalCount = 0;
    data.forEach((value) => {
      totalCount = totalCount + value.UnpostedAmount;
    });
    return totalCount;
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      size="xl"
      dialogClassName="custom-modal"
    >
      <style type="text/css">
        {`
          .custom-modal {
            max-width: 90%;
            width: 900px;
          }
          .modal-dialog {
            max-width: 90%;
            width: 900px;
            margin: 1.75rem auto;
          }
        `}
      </style>

      <Modal.Header
        closeButton={false}
        className="bg-black border text-white border-white"
      >
        <Modal.Title className="w-full">
          {props.projectCategoryId || ""}
        </Modal.Title>
        <button
          type="button"
          className="text-white hover:text-gray-300 focus:outline-none"
          onClick={handleClose}
        >
          ✕
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="relative flex-auto border-b-2 -mt-4 pb-[3px]">
          {/* Project Name Section */}
          <div className="grid grid-cols-1">
            <div className="relative items-start">
              <span className="font-bold text-sm text-center">
                Project Name:
              </span>
              <span className="font-normal text-sm ml-0 sm:ml-2">
                {props.projectName ? props.projectName : ""}
              </span>
            </div>
          </div>

          {/* Amount Section */}
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-2">
            <div className="relative flex items-start">
              <span className="font-bold text-sm w-full sm:w-auto text-center">
                Overall Budget:
              </span>
              <span className="font-normal text-sm ml-0 sm:ml-2">
                {(props.projectCategoryId === "Adv Vendor" ||
                  props.projectCategoryId === "Adv Emp")
                  ? "-"
                  : formatToINR(props.overallBudgetAmount)}
              </span>
            </div>
            <div className="relative flex flex-wrap items-start">
              <span className="font-bold text-sm w-full sm:w-auto text-center">
                Posted Amount:
              </span>
              <span className="font-normal text-sm ml-2 sm:ml-2">
                {formatToINR(props.postedAmount)}
              </span>
            </div>
            <div className="relative flex items-start">
              <span className="font-bold text-sm w-full sm:w-auto text-center">
                Unposted Amount:
              </span>
              <span className="font-normal text-sm ml-0 sm:ml-2">
                {formatToINR(props.unpostedAmount)}
              </span>
            </div>
            <div className="relative flex items-start">
              <span className="font-bold text-sm w-full sm:w-auto text-center">
                Balance Amount:
              </span>
              <span className="font-normal text-sm ml-0 sm:ml-2">
                {(props.projectCategoryId === "Adv Vendor" ||
                  props.projectCategoryId === "Adv Emp")
                  ? "-"
                  : formatToINR(
                      props.overallBudgetAmount -
                        (props.postedAmount + props.unpostedAmount)
                    )}
              </span>
            </div>
          </div>
        </div>

        {/* Table Section */}
        {!loading && !isError && data?.length > 0 ? (
          <div className="w-full mx-auto max-h-72 bg-white m-2 font-montserrat overflow-auto">
            <table className="min-w-full table-auto text-sm border border-gray-400">
              <thead className="sticky top-0 bg-slate-300 border-b border-gray-400">
                <tr>
                  <th className="px-2 py-2 font-bold border-r border-gray-400 text-center">
                    Project Trans Date
                  </th>
                  <th className="px-2 py-2 font-bold border-r border-gray-400 text-center">
                    Posted Amount
                  </th>
                  <th className="px-2 py-2 font-bold text-center">
                    Unposted Amount
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {data.map((row, index) => (
                  <tr
                    key={index}
                    className={`hover:bg-gray-50 ${
                      index % 2 === 0 ? "bg-slate-100" : "bg-white"
                    }`}
                  >
                    <td className="px-2 py-2 border-r border-gray-400 text-center">
                      {row.ProjectTransDate}
                    </td>
                    <td className="px-2 py-2 border-r border-gray-400 text-center">
                      {formatToINR(row.PostedAmount)}
                    </td>
                    <td className="px-2 py-2 text-center">
                      {formatToINR(row.UnpostedAmount)}
                    </td>
                  </tr>
                ))}
                <tr className="bg-gray-400">
                  <td className="px-2 py-2 font-semibold border-r border-gray-500 text-center">
                    Total:
                  </td>
                  <td className="px-2 py-2 font-semibold border-r border-gray-500 text-center">
                    {formatToINR(getTotalPosted(data))}
                  </td>
                  <td className="px-2 py-2 font-semibold text-center">
                    {formatToINR(getTotalUnposted(data))}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <>
            {loading && (
              <div className="flex items-center justify-center p-4">
                <BiLoaderCircle
                  className="animate-spin text-blue-500"
                  size={40}
                />
              </div>
            )}
            {!loading && !isError && data?.length === 0 && (
              <div className="flex items-center justify-center p-4 text-gray-500">
                No Data Found
              </div>
            )}
            {isError && (
              <div className="flex items-center justify-center p-4 text-red-500">
                Error fetching data. Please try again later.
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default NewModalCard;
